import { segmentStepFilterActions } from '../constants/filter';
import * as api from '../api/segment';
import { asyncAction } from './common';

export const fetchSegments = () => asyncAction('FETCH_SEGMENTS', api.fetchSegments());

export const createSegment = (segment) => asyncAction('UPDATE_SEGMENT', api.createSegment(segment));

export const updateSegment = (segment, id) =>
  asyncAction('UPDATE_SEGMENT', api.updateSegment(segment, id));

export const deleteSegment = (id) => asyncAction('DELETE_SEGMENT', api.deleteSegment(id));

export const startUpdateSegment = (segment = null) => ({
  type: 'START_UPDATE_SEGMENT',
  segment,
});

export const setSegmentName = (name) => ({
  type: 'UPDATE_SET_SEGMENT_NAME',
  name,
});

export const cancelUpdateSegment = () => ({
  type: 'CANCEL_UPDATE_SEGMENT',
});

export const addSegmentStep = () => ({
  type: 'UPDATE_SEGMENT_ADD_STEP',
});

export const changeSegmentStepPosition = (oldIndex, newIndex) => ({
  type: 'UPDATE_SEGMENT_CHANGE_STEP_POSITION',
  oldIndex,
  newIndex,
});

export const setSegmentStepEventName = (stepIndex, event) => ({
  type: 'UPDATE_SEGMENT_SET_EVENT_NAME',
  stepIndex,
  event,
});

export const setSegmentStepClosingRange = (stepIndex, closingRange) => ({
  type: 'UPDATE_SEGMENT_SET_CLOSING_RANGE',
  stepIndex,
  closingRange,
});

export const setSegmentStepType = (stepIndex, stepType) => ({
  type: 'UPDATE_SEGMENT_SET_STEP_TYPE',
  stepIndex,
  stepType,
});

export const setSegmentStepCount = (stepIndex, count, operator) => ({
  type: 'UPDATE_SEGMENT_SET_STEP_COUNT',
  count,
  operator,
  stepIndex,
});

export const removeSegmentStep = (stepIndex) => ({
  type: 'UPDATE_REMOVE_SEGMENT_STEP',
  stepIndex,
});

export const setSegmentDateRange = (from, to) => ({
  type: 'UPDATE_SEGMENT_SET_DATE_RANGE',
  dateRange:
    !!from && !!to
      ? {
          from,
          to,
        }
      : null,
});

export const addFilterClause = (stepIndex) => ({
  type: segmentStepFilterActions.ADD_FILTER_CLAUSE,
  stepIndex,
});

export const removeFilterClause = (stepIndex, id) => ({
  type: segmentStepFilterActions.REMOVE_FILTER_CLAUSE,
  id,
  stepIndex,
});

export const setFilterClauseField = (stepIndex, id, field, type) => ({
  type: segmentStepFilterActions.SET_FILTER_CLAUSE_FIELD,
  id,
  field,
  stepIndex,
  fieldType: type,
});

export const setFilterClauseValue = (stepIndex, id, value) => ({
  type: segmentStepFilterActions.SET_FILTER_CLAUSE_VALUE,
  id,
  value,
  stepIndex,
});

export const setClausesConcatOperator = (stepIndex, value) => ({
  type: segmentStepFilterActions.SET_CLAUSES_CONCAT_OPERATOR,
  value,
  stepIndex,
});

export const setFilterClauseOperator = (stepIndex, id, value, resetClauseValue) => ({
  type: segmentStepFilterActions.SET_FILTER_CLAUSE_OPERATOR,
  id,
  value,
  resetClauseValue,
  stepIndex,
});

export const setSegmentFilterValue = (value) => ({
  type: 'SEGMENT_FILTER_VALUE_CHANGED',
  filterValue: value,
});

export const selectSegment = (segment) => ({
  type: 'SELECT_SEGMENT',
  segment,
});

export const setSegmentSideListContainerWidth = (containerWidth) => ({
  type: 'SET_SEGMENT_SIDE_LIST_CONTAINER_WIDTH',
  containerWidth,
});

export const duplicateSegment = (item) => ({
  type: 'SEGMENT_SELECT_DUPLICATE_SEGMENT',
  item,
});
